import styled, { css } from 'styled-components';

interface IProps {
  sizeDisplay: 'lg' | 'sm' | 'md';
}

export const Container = styled.div<IProps>`
  ${(props) =>
    props.sizeDisplay === 'lg'
      ? css`
          width: 100%;
        `
      : props.sizeDisplay === 'md'
        ? css`
          width: calc(100% / 2 - 8px);
        `
        : css`
          width: calc(100% / 3 - 11px);
        `}
`;
